import { render, staticRenderFns } from "./EditPageDetailsLinkedPages.vue?vue&type=template&id=4fdf56b6&"
import script from "./EditPageDetailsLinkedPages.vue?vue&type=script&lang=js&"
export * from "./EditPageDetailsLinkedPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports